import { render, staticRenderFns } from "./picinvitemanageform.vue?vue&type=template&id=bf615aba&scoped=true&"
import script from "./picinvitemanageform.vue?vue&type=script&lang=js&"
export * from "./picinvitemanageform.vue?vue&type=script&lang=js&"
import style0 from "./picinvitemanageform.vue?vue&type=style&index=0&id=bf615aba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf615aba",
  null
  
)

export default component.exports